
import React from 'react';
import { FAQCategory, FAQItem } from '@/components/faq/types';

// Import categories and FAQ sections
import { faqCategories } from './faq/categories';
import { gettingStartedFAQs } from './faq/gettingStarted';
import { securityPrivacyFAQs } from './faq/securityPrivacy';
import { documentsFAQs } from './faq/documents';
import { remindersFAQs } from './faq/reminders';
import { platformFAQs } from './faq/platform';
import { emergencySupportFAQs } from './faq/emergencySupport';

// Export categories
export { faqCategories };

// Combine all FAQ sections
export const comprehensiveFAQs: FAQItem[] = [
  ...gettingStartedFAQs,
  ...securityPrivacyFAQs,
  ...documentsFAQs,
  ...remindersFAQs,
  ...platformFAQs,
  ...emergencySupportFAQs
];

export const allFAQs = comprehensiveFAQs;
